import axios from '@/utils/axiosHelper'

// 初始化
export const onInitAPI = (params) => {
    return axios({ url: '/snail/novice/index', method: 'GET', params }, { interceptResultCode: false })
}

// 未登录信息
export const onInfoAPI = (params) => {
    return axios({ url: '/snail/novice/not/login', method: 'GET', params }, { interceptResultCode: false })
}

// 注销
export const onLogoutAPI = (params) => {
    return axios({ url: '/game/my/disable', method: 'POST', params }, { interceptResultCode: false })
}

// 问卷提交
export const onQuestionAPI = (params) => {
    return axios({ url: '/snail/novice/question', method: 'POST', params }, { interceptResultCode: false })
}

// 领取奖励
export const onRewardAPI = (params) => {
    return axios({ url: '/snail/novice/reward', method: 'POST', params }, { interceptResultCode: false })
}

// 免登录
export const onAutoAPI = (params) => {
    return axios({ url: '/snail/clock/uuid', method: 'POST', params }, { interceptResultCode: false })
}


// WEBPACK FOOTER //
// ./src/pages/snail/questionnaire/api.js